module.exports = __webpack_public_path__ + "img/nrslogovectorallwhitestacked@3x.9ac3b351.png";